module.exports = __webpack_public_path__ + "static/media/marketing.4998dcc1.svg";